import React, {FC, Fragment} from "react"

import {WellnessLane} from "@irati/types"
import Spacing from "@irati/ui/src/Spacing"
import Slider from "@irati/ui/src/Slider"
import {H3} from "@irati/ui/src/Typography"
import {Hr} from "@irati/ui/src/Layout"
import {SliderSettings} from "../containers/styled"
import MediaCard from "./MediaCard"

interface Props {
  lane: WellnessLane,
  laneKey: Number
}

const WellnessLanes: FC<Props> = ({lane, laneKey}) => {
  return(
    <Fragment>
      <H3 marginBottom>
        {lane.title}
      </H3>

      <Spacing marginLeft={-1} marginRight={-1}>
        <Slider slidesToShow={lane.mediaCardCount} settings={SliderSettings}>
          {lane.mediaList.map((m, index) => (
            <MediaCard
              media={m}
              key={m.uuid}
              lane={lane}
              lanePosition={laneKey + 1}
              mediaPositionInLane={index + 1} />
          ))}
        </Slider>
      </Spacing>

      {!lane.mediaList.length && `No media found for lane: ${lane.uuid}`}
      <Hr />
    </Fragment>
  )
}

export default WellnessLanes